import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import {selectMyAppointments} from '../../../../store/selectors'
import MainHeaderWrapper from '../../../../components/MainHeaderWrapper'
import MainContentWrapper from '../../../../components/MainContentWrapper';
import AppointmentsTable from '../../../../components/AppointmentsTable';
import H3 from '../../../../components/elements/H3'
import AppointmentDetailDrawer from '../../../../components/AppointmentDetailDrawer'
import {Tab, TabsMenu} from '../../../../components/Tabs'


const MyAppointmentsPage = (props) =>{
    const [_selected, _setSelected] = useState()
    const [_section, _setSection] = useState("TODAY")
    const handleRowSelect = rowInfo =>{
        _setSelected(rowInfo)
    }

    const handleCloseDrawerRequested = () =>{
        _setSelected()
    }
    const handleTabClicked = (section) => {
        _setSection(section)
    }
    

    return (
        <React.Fragment>
            <MainContentWrapper>
            <MainHeaderWrapper>
                <H3
                lineHeight="40px"
                >Meine Aufgaben</H3>
            </MainHeaderWrapper>
                <TabsMenu>
                    <Tab onClick={handleTabClicked} name="TODAY" title="Heute"></Tab>
                    <Tab onClick={handleTabClicked} name="OPEN" title="Offen"></Tab>
                    <Tab onClick={handleTabClicked} name="DONE" title="Erledigt"></Tab>
                </TabsMenu>
                <AppointmentsTable own section={_section}  selected={_selected && _selected.index} onRowSelect={handleRowSelect} data={props.appointments}/>
            </MainContentWrapper>
            <AppointmentDetailDrawer 
            id={_selected && _selected.original.id}
            onRequestClose={handleCloseDrawerRequested}
            />
        </React.Fragment>
    )
}

const mapStateToProps = state =>({
    appointments: selectMyAppointments(state)
})

export default connect(mapStateToProps, null)(MyAppointmentsPage)

